/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconMiscRadar = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        d="M7.357 6.973a1.544 1.544 0 1 0 1.77.355.77.77 0 1 1 1.13-1.05 3.087 3.087 0 1 1-2.9-.92v-.785a3.86 3.86 0 0 0 .639 7.664 3.858 3.858 0 0 0 2.846-6.463.772.772 0 0 1 1.138-1.042 5.4 5.4 0 1 1-4.623-1.717v-.87a6.174 6.174 0 1 0 5.193 1.972.772.772 0 1 1 1.138-1.042A7.716 7.716 0 1 1 7.378.593.772.772 0 0 1 8.9.772v7.716a.772.772 0 0 1-1.543 0V6.973z"
        fill="currentColor"
      />
    </g>
  </svg>
);

IconMiscRadar.displayName = 'IconMiscRadar';

IconMiscRadar.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconMiscRadar);
IconMiscRadar.displayName = 'IconMiscRadar';
